import { createAnalyticsTracker } from 'v2/analytics/events';

export const trackManageUnifiedFieldsPageEvent = createAnalyticsTracker(
  'manageUnifiedFieldPageEvents',
);
